const root = document.querySelector(':root')

export default function setCssVariable(name, value) {
  root.style.setProperty(name, value);
}